export default {
    namespaced: true,
    state: {
        parametros: {},
        preferencias: {},
        webconfig: {},
        whatsapp: {},
        chat: {},
        movilconfig: {},
        contacto: {},
        social: {},
        analytics: {},
        googlecalendar: {},
        googlemaps: {},
        login: {
            url: '/login'
        }
    },
    actions: {
        getPreferences: async function ({ commit }) {
            let response = await axios.get("/api/parametros");
            if (response) {
                let decode = response.decode ?? response;
                decode.data.forEach((param) => {
                    if (param.clave == "preferencias") {
                        commit("setPreferencias", { data: param });
                    }
                    if (param.clave == "social") {
                        commit("setSocial", { data: param });
                    }
                    if (param.clave == "googlemaps") {
                        commit("setGoogle", { data: param });
                    }
                    if (param.clave == "contacto") {
                        commit("setContact", { data: param });
                    }
                    if (param.clave == "webconfig") {
                        commit("setWeb", { data: param });
                    }
                    if (param.clave == "whatsapp") {
                        commit("setWhatsapp", { data: param });
                    }
                    if (param.clave == "chat") {
                        commit("setChat", {data: param})
                    }
                    if (param.clave == "movilconfig") {
                        commit("setMovil", { data: param });
                    }
                    if (param.clave == "googlecalendar") {
                        commit("setGooglecalendar", { data: param });
                    }
                    if (param.clave == "analytics") {
                        commit("setAnalytics", { data: param });
                    }
                });
                commit("setParametros", { data: decode.data });
            }
        },
    },
    mutations: {
        setParametros(state, payload) {
            if (payload.data != undefined) {
                state.parametros = payload.data;
            }
        },
        setPreferencias(state, payload) {
            if (payload.data != undefined) {
                state.preferencias = payload.data;
            }
        },
        setGoogle(state, payload) {
            if (payload.data != undefined) {
                state.googlemaps = payload.data;
            }
        },
        setSocial(state, payload) {
            if (payload.data != undefined) {
                state.social = payload.data;
            }
        },
        setContact(state, payload) {
            if (payload.data != undefined) {
                state.contacto = payload.data;
            }
        },
        setWeb(state, payload) {
            if (payload.data != undefined) {
                state.webconfig = payload.data;
            }
        },
        setWhatsapp(state, payload) {
            if (payload.data != undefined) {
                state.whatsapp = payload.data;
            }
        },
        setChat(state, payload) {
            if (payload.data != undefined) {
                state.chat = payload.data
            }
        },
        setMovil(state, payload) {
            if (payload.data != undefined) {
                state.movilconfig = payload.data;
            }
        },
        setGooglecalendar(state, payload) {
            if (payload.data != undefined) {
                state.googlecalendar = payload.data;
            }
        },
        setAnalytics(state, payload) {
            if (payload.data != undefined) {
                state.analytics = payload.data;
            }
        },
    },
};
